import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import KeyValueList from 'components/key-value-list';
import styles from './styles.css';

export default class ExtraData extends Component {
    static propTypes = {
        order: PropTypes.object.isRequired,
    };

    render() {
        const {order} = this.props;

        const renderingKeys = [];

        if (order.category.id.includes('signs') || order.category.id.includes('bags')) {
            renderingKeys.push({key: 'notes', label: 'Comentarios para Nidera'});
        }

        if (order.category.id.includes('crops')) {
            renderingKeys.push(
                {key: 'locality', label: 'Localidad Campo Líder', format: ({label}) => label},
                {key: 'crops', label: 'Cultivos a sembrar', format: value => value.join(', ')},
            );
        }

        if (order.category.id.includes('kits')) {
            renderingKeys.push(
                {key: 'attendees', label: 'Cantidad de invitados'},
                {key: 'notes', label: 'Comentarios para Nidera'},
                {
                    key: 'makeInvitations',
                    label: 'Necesita invitaciones',
                    format: value => value ? 'Sí' : 'No',
                },
                {key: 'date', label: 'Fecha', format: value => moment(value).format('LL')},
                {key: 'dateFrom', label: 'Fecha desde', format: value => moment(value).format('LL')},
                {key: 'dateTo', label: 'Fecha hasta', format: value => moment(value).format('LL')},

                {key: 'time', label: 'Hora', format: value => moment(value, 'HH:mm:ss').format('HH:mm')},
                {key: 'rsvpEmail', label: 'Email de confirmación'},
                {key: 'rsvpPhone', label: 'Teléfono de confirmación'},
                {key: 'locationName', label: 'Establecimiento'},
                {key: 'locationAddress', label: 'Dirección del establecimiento'},
                {
                    key: 'locationLocality',
                    label: 'Localidad del establecimiento',
                    format: ({label}) => label,
                },
                {key: 'topics', label: 'Temas y disertantes'},
                {key: 'extraInfo', label: 'Información adicional'},
            );
        }

        if (order.refund) {
            renderingKeys.push(
                {key: 'destination', label: 'Destino'},
                {key: 'date', label: 'Fecha', format: value => moment(value).format('LL')},
                {key: 'dateFrom', label: 'Fecha desde', format: value => moment(value).format('LL')},
                {key: 'dateTo', label: 'Fecha hasta', format: value => moment(value).format('LL')},
                {key: 'estimatedDate', label: 'Fecha estimada', format: value => moment(value).format('LL')},
                {key: 'title', label: 'Título'},
                {key: 'description', label: 'Descripción'},
                {key: 'organizer', label: 'Organizador'},
                {key: 'eventName', label: 'Evento'},
                {key: 'eventLocality', label: 'Localidad del evento', format: ({label}) => label},
                {key: 'attendees', label: 'Cantidad de invitados'},
                {key: 'type', label: 'Tipo'},
                {key: 'mediumName', label: 'Nombre del medio'},
                {key: 'specifications', label: 'Especificaciones de la pauta'},
                {key: 'notes', label: 'Comentarios para Nidera'},
            );
        }

        if (order.category.id === 'merchandising') {
            renderingKeys.push({key: 'notes', label: 'Comentarios para Nidera'});
        }

        if (order.category.id === 'jt_dealer_refund') {
            renderingKeys.push({
                key: 'kitEvent',
                label: 'Kit de evento',
                format: value => value ? 'Sí' : 'No',
            });
        }

        if (order.category.id === 'jt_multiplier_refund') {
            renderingKeys.push({key: 'sponsorshipType', label: 'Tipo de auspicio'});
        }

        return (
            <div className={styles.root}>
                <div className={styles.cardHeader}>Información adicional</div>
                <div className={classNames(styles.cardBody, styles.cardBodyRefund)}>
                    <KeyValueList
                        data={order.extraData}
                        rows={renderingKeys}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-detail/extra-data/index.js